import { ArrowUpRight } from '@phosphor-icons/react'
import { Link } from 'src/design-system'
import * as Popover from '@radix-ui/react-popover'
import * as React from 'react'
import { ContentLicenseGrant } from 'store/modules/content-license-grants'
import * as MegaModal from '../../mega-modal'

export const LicenseInfoLine: React.VFC<{ license: ContentLicenseGrant }> = (
  props
) => {
  const { license } = props

  return (
    <MegaModal.InfoLine
      label="License"
      value={
        <Popover.Root>
          <Popover.Trigger className="text-gray-900 text-left underline">
            {license.licenseName}
          </Popover.Trigger>
          <Popover.Content align="start" sideOffset={8}>
            <div className="w-64">
              <div className="bg-gray-100 border border-gray-100 font-bold px-4 py-2 rounded-t-lg">
                License: {license.licenseName}
              </div>
              <div className="bg-white border border-gray-100 flex flex-col gap-1 p-4 rounded-b-lg">
                {license.licenseDescription && (
                  <p className="mb-0">{license.licenseDescription}</p>
                )}
                {license.licenseLink && (
                  <Link
                    className="p-0"
                    href={license.licenseLink}
                    isExternal
                    underline={false}
                  >
                    View license <ArrowUpRight />
                  </Link>
                )}
                {license.description && (
                  <>
                    <hr className="w-full" />
                    <p className="font-bold mb-0">From the author</p>
                    <p className="mb-0">{license.description}</p>
                  </>
                )}
                {license.link && (
                  <Link
                    className="p-0"
                    href={license.link}
                    isExternal
                    underline={false}
                  >
                    View original <ArrowUpRight />
                  </Link>
                )}
              </div>
            </div>
          </Popover.Content>
        </Popover.Root>
      }
    />
  )
}
